<!-- eslint-disable max-lines -->
<template>
    <!-- 逾期 弹框 -->
    <el-dialog
        :closeOnClickModal='false'
        class="overdue receiptSignOverdue"
        title="逾期"
        :visible="true"
        :before-close="beforeClose"
        width="40%">
        <el-form
            ref="overdueForm"
            class="demo-ruleForm">
            <el-form-item class="label-form1">
                <el-select v-model="overdueForm.overdueType" placeholder="逾期类型" @change='change'>
                    <el-option
                        v-for="(item, index) in overdueTypeOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
             <el-form-item class="label-form2">
                <el-select v-model="overdueForm.overdueReason" placeholder="一级逾期原因" clearable
                 @change="ReasonChange">
                    <el-option
                        v-for="(item, index) in overdueCauseTypeOption"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="label-form2">
                <el-select v-model="overdueForm.overdueReasDetail" placeholder="二级逾期原因" clearable
                    @change="reasDetailChange">
                    <el-option
                        v-for="(item, index) in overdueCauseTypeOptions2"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-input type="textarea" clearable placeholder="逾期原因描述" :autosize="{ minRows: 2, maxRows: 4}" v-model.trim="overdueForm.overdueDesc"></el-input>
        <el-row :gutter="20" class="return-visit-info" v-if="
        (+overdueForm.overdueType === 1 && +overdueForm.overdueReason === 1 && ['1_01', '1_02', '1_03', '1_04', '1_05', '1_06'].includes(overdueForm.overdueReasDetail)) ||
        (+overdueForm.overdueType === 0 && +overdueForm.overdueReason === 1 && ['1_03', '1_04', '1_05', '1_06', '1_07', '1_08'].includes(overdueForm.overdueReasDetail))">
            <el-col :span="12">
                <el-input class="mustFillLabel" :class="{mustFill: !overdueForm.revisiter}" clearable placeholder="被回访人" v-model.trim="overdueForm.revisiter"></el-input>
            </el-col>
            <el-col :span="12">
                <el-input class="mustFillLabel" :class="{mustFill: !overdueForm.revisiterMobile}" clearable placeholder="被回访人电话" v-model.trim="overdueForm.revisiterMobile"></el-input>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="confirm">确 认</el-button>
        </div>
    </el-dialog>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import { receiptOverdue } from '../../../api/receiptSign';
import { mapState } from 'vuex';

export default {
    props: {
        overdueShaowDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        selectData: {
            type: Array,
            default() {
                return [];
            }
        },
        overdueTypeOptions: {
            type: Array,
            default() {
                return [];
            }
        },
        overdueCauseTypeOptions: {
            type: Object,
            default() {
                return {};
            }
        },
        searchObj: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            overdueCauseTypeOption: [],
            dialogLoading: {}, // 弹框loading实例
            overdueForm: {
                overdueType: '',
                overdueCauseType: [],
                overdueDesc: '',
                overdueReason: '',
                overdueReasDetail: '',
                revisiter: '',
                revisiterMobile: ''
            },
            overdueCauseTypeOptions2: []
        };
    },
    methods: {
        change(value) {
            this.overdueForm.overdueReason = '';
            this.overdueCauseTypeOption = this.overdueCauseTypeOptions[value];
        },
        ReasonChange(OverdueReason) {
            this.overdueForm.overdueReasDetail = '';
            this.overdueCauseTypeOption.forEach(item => {
                if (item.value === OverdueReason) {
                    this.overdueCauseTypeOptions2 = item.children;
                }
            });
        },
        reasDetailChange(overdueReasDetail) {
            if (!((+this.overdueForm.overdueType === 1 && +this.overdueForm.overdueReason === 1 && ['1_01', '1_02', '1_03', '1_04', '1_05', '1_06'].includes(this.overdueForm.overdueReasDetail)) ||
                (+this.overdueForm.overdueType === 0 && +this.overdueForm.overdueReason === 1 && ['1_03', '1_04', '1_05', '1_06', '1_07', '1_08'].includes(this.overdueForm.overdueReasDetail)))
            ) {
                this.overdueForm.revisiterMobile = this.overdueForm.revisiter = '';
            }
        },
        loading(status = true) {
            if (status) {
                this.dialogLoading = this.$loading({
                    target: '.receiptSignOverdue > div',
                    background: 'rgba(255, 255, 255, .7)'
                });
            } else {
                this.dialogLoading.close();
            }
        },
        confirm() {
            // const reg = /^1\d{10}$/; // 手机号校验
            if (this.overdueForm.overdueType === '') {
                this.$message({
                    message: '请选择逾期类型',
                    type: 'warning'
                });
                return false;
            }
            if (!(this.overdueForm.overdueReasDetail)) {
                this.$message({
                    message: '请选择逾期原因',
                    type: 'warning'
                });
                return false;
            }
            if ((+this.overdueForm.overdueType === 1 && +this.overdueForm.overdueReason === 1 && ['1_01', '1_02', '1_03', '1_04', '1_05', '1_06'].includes(this.overdueForm.overdueReasDetail)) ||
                (+this.overdueForm.overdueType === 0 && +this.overdueForm.overdueReason === 1 && ['1_03', '1_04', '1_05', '1_06', '1_07', '1_08'].includes(this.overdueForm.overdueReasDetail))
            ) {
                if (!(this.overdueForm.revisiterMobile && this.overdueForm.revisiter)) return this.$message.warning('请填写被访问人信息');
                // if (!reg.test(this.overdueForm.revisiterMobile)) return this.$message.warning('请正确输入被访问人手机号！');
            }
            const params = {};
            const mapObj = {};
            this.selectData.forEach(item => {
                mapObj[item.taskNo] = item.dispatchNo;
            });
            params.map = mapObj;
            params.overdueType = this.overdueForm.overdueType;
            params.overdueDesc = this.overdueForm.overdueDesc;
            params.overdueReason = this.overdueForm.overdueReason;
            params.overdueReasDetail = this.overdueForm.overdueReasDetail;
            params.revisiter = this.overdueForm.revisiter;
            params.revisiterMobile = this.overdueForm.revisiterMobile;
            params.createUserCode = this.user.userCode;
            params.createUserName = this.user.userName;

            this.loading();
            receiptOverdue(params).then(res => {
                if (res) {
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                }
                this.$emit('update:overdueShaowDialog', false);
                this.$emit('refreshList', this.searchObj); // 更新首页列表数据
            }).catch(() => {
                this.loading(false);
            });
        },
        beforeClose() {
            this.$confirm('您确定要取消编辑吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('update:overdueShaowDialog', false);
            }).catch(() => {
            });
        }
    },
    computed: {
        ...mapState({ user: state => state.user })
    }

};
</script>

<style lang="less">
.receiptSignOverdue > div {
    min-width: 670px;
}
.receiptTile {
    .demo-ruleForm {
        display: flex;
        .label-form1 {
            width: 180px;
        }
        .label-form2 {
            flex: 1;
            text-align: right;
        }
    }
}
.receiptSignOverdue {
    .return-visit-info {
        margin-top: 27px;
    }
    .mustFillLabel{
        &:before{
            content:'* ';
            color:red;
        }
        .el-input__inner {
            width: 97%;
        }
    }
    .mustFill{
        .el-input__inner{
            border:1px solid red;
        }
    }
}
</style>
